/**
 * Ensures the function only every runs once no matter how many times it is
 * called.
 * When the new function is called nothing is ever returned.
 */
export const callOnceOnly = function (func) {
  var isCalled = false
  return function () {
    if (isCalled) return
    isCalled = true
    func.apply(this, arguments)
  }
}